import React, { useEffect, useMemo, useState } from 'react';
import './CabsPolicies.css';

export const CabsPolicies = ({ data }) => {
  const { tabs } = data;
  const [tabList, setTabList] = useState<
    Array<{ id: string; label: string; url: string; active: boolean }>
  >([]);
  const [selectedTab, setSelectedTab] = useState(
    tabs.find(tab => tab.active)?.id
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const _tabs = urlParams.get('tab')
      ? tabs.filter(tab => urlParams.get('tab')?.includes(tab.id))
      : tabs;

    setTabList(_tabs);
    setSelectedTab(urlParams.get('active') || _tabs[0].id);
  }, [tabs]);

  const org = useMemo(() => {
    if (global.window) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('org') || 'mmt';
    }
    return 'mmt';
  }, []);

  return (
    <div className="page">
      <div className="tabs">
        {tabList.map((tab, index) => (
          <div
            key={index}
            className={`tab ${selectedTab === tab.id ? 'active' : ''}`}
            onClick={e => {
              e.preventDefault();
              setSelectedTab(tab.id);
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>
      <div className="iframe-container">
        <iframe
          src={`${tabList.find(tab => tab.id === selectedTab)?.url}?org=${org}`}
          title="Tab Content"
          className="iframe"
        ></iframe>
      </div>
    </div>
  );
};

CabsPolicies.fetchData = async (_, _match, urlObj) => {
  const cacheKey = 'HTML_STATIC_DOC_CABS-POLICIES.HTML';
  const tabs: Array<{
    id: string;
    label: string;
    url: string;
    active: boolean;
  }> = [];

  tabs.push({
    id: 'rg',
    label: 'Ride Guarantee',
    url: 'https://www.makemytrip.com/doc/ride-guarantee.html',
    active: true
  });

  tabs.push({
    id: 'ot',
    label: 'Other Policies',
    url: 'https://promos.makemytrip.com/flight-addon-terms.html',
    active: false
  });

  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    templateData: {
      templateName: 'DOC_CABS_POLICIES',
      metaTitle: 'Cabs Policies',
      metaDescription: '',
      metaKeywords: '',
      analytics: ``,
      h1Title: 'Cabs Policies',
      extraInfo: '',
      breadcrumb: [],
      externalJs: '',
      descriptionInHtml: ``
    },
    tabs
  };
};

export default CabsPolicies;
